var map = {
	"./ic-zone-0.png": 61883,
	"./ic-zone-1.png": 39044,
	"./ic-zone-2.png": 29534,
	"./ic-zone-3.png": 12143,
	"./ic-zone-4.png": 62967,
	"./ic-zone-5.png": 14587
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 41768;